import Box from "ds/components/Box";
import Badge from "ds/components/Badge";

import { getDoraTimeUnit } from "../helpers";
import DoraTimeAverage from "../components/DoraTimeAverage";
import DoraEmpty from "../components/Empty";
import DoraTimeRange from "../components/DoraTimeRange";
import { getDoraGrade } from "../getDoraGrade";
import useDoraChartType from "../useChartType";
import useDoraTimeToRecoveryAverage from "./useAverage";
import useDoraTimeToRecoveryRange from "./useRange";
import { CHART_TYPE_STORAGE_KEY, TIME_TO_RECOVERY_THRESHOLDS } from "./constants";

const DashboardWidgetsDoraTimeToRecovery = () => {
  const { averageSeconds, isLoading: isAverageLoading } = useDoraTimeToRecoveryAverage();
  const { range, hasRuns } = useDoraTimeToRecoveryRange();
  const { chartType } = useDoraChartType(CHART_TYPE_STORAGE_KEY);

  const hasData = hasRuns && !!range?.length;

  if (!hasData) {
    return (
      <DoraEmpty
        title="No recovery data available"
        caption="Recovery time is measured from stack failure to next successful tracked run"
      />
    );
  }

  const unit = getDoraTimeUnit(averageSeconds ?? 0);
  const grade = getDoraGrade(averageSeconds ?? 0, TIME_TO_RECOVERY_THRESHOLDS);

  return (
    <Box direction="column" gap="x-large" fullWidth>
      <DoraTimeAverage
        averageSeconds={averageSeconds ?? 0}
        isLoading={isAverageLoading}
        badge={grade && <Badge variant={grade.badgeVariant} type="weak" text={grade.label} />}
      />
      <DoraTimeRange
        range={range}
        unit={unit}
        chartType={chartType}
        gradeThresholds={TIME_TO_RECOVERY_THRESHOLDS}
      />
    </Box>
  );
};

export default DashboardWidgetsDoraTimeToRecovery;
